/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayersIntersect2 = createReactComponent(
  "layers-intersect-2",
  "IconLayersIntersect2",
  [
    [
      "path",
      {
        d: "M8 4m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z",
        key: "svg-0"
      }
    ],
    [
      "path",
      {
        d: "M4 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z",
        key: "svg-1"
      }
    ],
    ["path", { d: "M9 15l6 -6", key: "svg-2" }]
  ]
);

export { IconLayersIntersect2 as default };
//# sourceMappingURL=IconLayersIntersect2.js.map
